export const sortTopics = (topicDict, topicIDs) => {
	return [...topicIDs].sort((a, b) => {
		if (topicDict[a].name.includes("Al-Fatiha - The Lord's Prayer")) return -1; // Hard code Al fatiha to be at top of topics
		if (topicDict[b].name.includes("Al-Fatiha - The Lord's Prayer")) return 1;
		if (topicDict[a].name > topicDict[b].name) return 1;
		if (topicDict[a].name < topicDict[b].name) return -1;
		return 0;
	});
};
